import { Outlet, Link } from 'react-router-dom';
import { useI18n } from '../i18n';
import LanguageSwitcher from './LanguageSwitcher';

export default function Layout() {
    const { t } = useI18n();

    return (
        <div className="min-h-screen flex flex-col">
            <header className="bg-white border-b border-gray-200 sticky top-0 z-10">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <Link to="/" className="text-2xl font-bold text-primary-600">
                            GetDev.Tools
                        </Link>
                        <nav className="flex gap-4 items-center">
                            <Link to="/" className="text-gray-600 hover:text-primary-600 transition-colors">
                                {t.common.home}
                            </Link>
                            <a
                                href="https://github.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-600 hover:text-primary-600 transition-colors"
                            >
                                {t.common.github}
                            </a>
                            <LanguageSwitcher />
                        </nav>
                    </div>
                </div>
            </header>

            <main className="flex-1 container mx-auto px-4 py-8">
                <Outlet />
            </main>

            <footer className="bg-gray-100 border-t border-gray-200 py-6">
                <div className="container mx-auto px-4 text-center text-gray-600">
                    <p>{t.home.footer}</p>
                    <p className="text-sm mt-2">{t.home.footerSubtitle}</p>
                </div>
            </footer>
        </div>
    );
}